module.exports = __webpack_public_path__ + "static/media/right-sidebar-right-img.6fbd3363.jpg";